import { Image } from '@chakra-ui/react'
import React from 'react'
import { LogoProps } from './interfaces'
import LogosTypes from './types'

export const Logo: React.FC<LogoProps> = ({ type = 'default', ...props }) => {
    const Logo = LogosTypes[type]
    return (
        <Image
            objectFit="cover"
            src={Logo}
            alt="Logo RegistrAuto"
            loading="lazy"
            marginX="auto"
            width="100%"
            {...props}
        />
    )
}
